import { DepartmentVisibilities } from "../../shared/enums/departmentVisibility.enum";
import { FilterTypes } from "../../shared/enums/filterTypes";
import { EmployeeDetailsViewModel } from "../../shared/viewModels/employeeDetailsViewModel";
import { PermissionViewModel } from "../../shared/viewModels/permissionViewModel";
import { ModuleTypes } from "../enums/moduleTypes";
import { ReadWriteTypes } from "../enums/readWriteTypes";

export class PermissionHelper {
  static getDepartmentVisibility(employee: EmployeeDetailsViewModel, readOrWrite: ReadWriteTypes, filterType: FilterTypes, module: ModuleTypes, confidential = false): DepartmentVisibilities {
    const found = employee.permissions.filter(
      (f) =>
        f.module === module &&
        f.type === filterType &&
        (readOrWrite === ReadWriteTypes.read ? f[ReadWriteTypes.read] && !f[ReadWriteTypes.write] : f[ReadWriteTypes.write]) &&
        f.confidential === confidential
    );

    if (found && found.length > 0) {
      return found[0].departmentVisibility;
    }
  }

  static   changeDepartmentVisibility(
    employee: EmployeeDetailsViewModel,
    currentDepVisibility: DepartmentVisibilities,
    module: ModuleTypes,
    filterType: FilterTypes,
    readOrWrite: ReadWriteTypes,
    confidential = false
  ) {
    if (readOrWrite === ReadWriteTypes.read) {
      employee.permissions.forEach((f) => {
        if (f.module === module && f.type === filterType && f.read && !f.write && f.confidential === confidential) {
          f.departmentVisibility = currentDepVisibility;
        }
      });
    } else if (readOrWrite === ReadWriteTypes.write) {
      employee.permissions.forEach((f) => {
        if (f.module === module && f.type === filterType && f.write && f.confidential === confidential) {
          f.departmentVisibility = currentDepVisibility;
        }
      });
      // If opeartions is for Write and depVisibility is for All Departments we need to set the READ permission for that object to be also for ALl Departments
      if (currentDepVisibility === DepartmentVisibilities.All_Departments) {
        employee.permissions.forEach((f) => {
          if (f.module === module && f.type === filterType && f.read && !f.write && f.confidential === confidential) {
            f.departmentVisibility = DepartmentVisibilities.All_Departments;
          }
        });
      } else if (currentDepVisibility === DepartmentVisibilities.Only_User_Department) {
        // Else If Only_User_Department we need to set all read permissions with NOTHING to Only_USER Department
        employee.permissions.forEach((f) => {
          if (
            f.module === module &&
            f.type === filterType &&
            f.read &&
            !f.write &&
            f.confidential === confidential &&
            f.departmentVisibility === DepartmentVisibilities.Nothing
          ) {
            f.departmentVisibility = DepartmentVisibilities.Only_User_Department;
          }
        });
      }
    }
  }

  static hasWritePermission(employee: EmployeeDetailsViewModel, isInPrimaryRole: boolean, module: ModuleTypes, type: FilterTypes, values: number[], confidential: boolean): boolean {
    let hasWritePermission = false;

    if (isInPrimaryRole) {
      hasWritePermission = true;
    } else if (employee.permissions) {
      const permission = employee.permissions.find(
        (p) =>
          p.module === module &&
          (p.type === type || p.type === FilterTypes.Empty) &&
          p.write &&
          (p.value === 0 || values.indexOf(p.value) !== -1) &&
          p.confidential == confidential
      );
      if (permission) {
        hasWritePermission = true;
      }
    }

    return hasWritePermission;
  }

  static generatePermission(
    employeeId: number,
    accountId: number,
    createdById: number,
    module: ModuleTypes,
    filterType: FilterTypes,
    value: number,
    departmentVisibility: DepartmentVisibilities,
    readOrWrite: ReadWriteTypes,
    confidential: boolean,
    level: number = 0
  ) {
    const obj: PermissionViewModel = {
      module: module,
      type: filterType,
      value: value,
      departmentVisibility: departmentVisibility,
      read: readOrWrite === ReadWriteTypes.read || readOrWrite === ReadWriteTypes.write,
      write: readOrWrite === ReadWriteTypes.write,
      confidential: confidential,
      level: level,
      employeeId: employeeId,
      accountId: +accountId,
      id: 0,
      createdById: createdById
    };
    return obj;
  }
}
